import axios from 'axios'

export async function get (url, data) {
  let resp = await axios.get(`/api/${url}`, { params: data })
  return getDataFromResponse(resp)
}

export async function post (url, data) {
  let resp = await axios.post(`/api/${url}`, data)
  return getDataFromResponse(resp)
}

// 处理 response
export function getDataFromResponse (resp) {
  const { data } = resp
  if (!data || data.code > 0 || data.status > 0) {
    console.error(resp.config.method, resp.config.url, resp.config.params, resp.config.data, data)
    throw data || resp
  }
  return data.data
}

export default {
  get,
  post,
  getDataFromResponse,
}
